"use client"

import { createFileRoute, Link, useParams } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { AnnouncementComposer } from "@/features/feature-announcements/components/announcement-composer"

export const Route = createFileRoute(
  "/$store/_layout/admin_/feature-announcements_/new",
)({
  component: NewAnnouncementPage,
})

function NewAnnouncementPage() {
  const { store } = useParams({ strict: false }) as { store: string }

  return (
    <div className="flex flex-col gap-6 px-4 py-6 lg:px-6">
      <div className="flex items-center gap-3">
        <Link
          to="/$store/admin/feature-announcements"
          params={{ store }}
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="size-4" />
          Voltar
        </Link>
      </div>
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Novo comunicado</h1>
        <p className="text-sm text-muted-foreground">
          Preencha o conteúdo e envie para todos os lojistas da plataforma.
        </p>
      </div>
      <AnnouncementComposer />
    </div>
  )
}
